<template>
  <custom-dialog width="1200px" :append-to-body="true" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body" style="padding: 0 24px">
      <div class="search-hd">
        <el-form :inline="true" @submit.native.prevent>
          <el-form-item style="float: right; margin-right: 0">
             <custom-column ref="column"></custom-column>
          </el-form-item>
          <el-form-item v-if="funcView.project_add">
            <el-button type="primary" icon="el-icon-plus" @click="addProject()">{{ $t('Common.com_add') }}</el-button>
          </el-form-item>
          <!-- 搜索栏 -->
          <el-form-item style="float: right">
            <search-input v-model="formSearch.search" :placeholder="$t('dms_location_select_dialog.xmmcxmbq')" @fetch="onPageChange({ page: 1 })"></search-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-bd">
        <custom-table
          type="radio"
          tableCode="location_select"
          v-model="selectedRow"
         :data="tableList"
          :column="tableColumn"
          @sort="sortChange"
           @column="setColumn"
          @filter="filterChange"
           :slots="['detailAddress', 'action']"
          height="500px"
        >
        <template v-slot:detailAddress="scope">{{ scope.row.country || '' }}{{ scope.row.province || '' }}{{ scope.row.city || '' }}{{ scope.row.detailAddress }}</template>
        <template v-slot:action="scope">
          <el-button type="text" size="mini" v-if="funcView.project_edit" @click="editProject(scope.row)">{{ $t('Common.com_edit') }}</el-button>
          <el-button type="text" size="mini" v-if="funcView.project_delete" @click="delProject(scope.row)">{{ $t('Common.com_delete') }}</el-button>
        </template>
        </custom-table>
      </div>
      <div class="table-page">
        <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button size="small" type="primary" :disabled="!Object.keys(selectedRow).length" @click="confirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
    <project-item-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="getTableList()"></project-item-dialog>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';
import projectItemDialog from '@/components/addProjectDialog.vue';

export default {
  mixins: [dialogMixins],
  components: {
    projectItemDialog,
  },
  data() {
    return {

      formSearch: {
        search: '',
        orderBy: '',
        productCode: '',
        bizTypeList: [],
        orderType: '',
        pageSize: 20,
        pageNum: 1,
        orgId: '',
        orgName: '',
      },
      dialogVisible: false,
      dialogModel: {},
      selectedRow: {},
      tableList: [],
      totalRows: 0
    };
  },
  mounted() {
    this.getTableList();
    this.getFuncView('/project');
  },
  methods: {
    // 获取表格数据
    getTableList: function () {
      this.formSearch.orgId = this.model.data.orgId;
      this.formSearch.orgName = this.model.data.orgName;
      this.$getJSON(apis.locationPage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 添加项目
    addProject: function () {
      const title = this.$t('dms_location_select_dialog.tian_jia_xiang_mu');
      this.dialogModel.type = 'specialAdd';
      this.dialogModel.title = title;
      this.dialogModel.data = {
        orgId: this.model.data.orgId,
        orgName: this.model.data.orgName
      };
      this.dialogVisible = true;
    },
    editProject(data) {
      const title = this.$t('dms_location_select_dialog.bian_ji_xiang_mu');
      this.dialogModel.type = 'edit';
      this.dialogModel.title = title;
      this.dialogModel.id = data.locationId;
      this.dialogModel.data = {
        orgId: this.model.data.orgId,
        orgName: this.model.data.orgName,
        ...data
      };
      this.dialogVisible = true;
    },
    delProject: function (data) {
      const title = this.$t('dms_location_select_dialog.nqdysccxmm');
      this.$showConfirm(title)
        .then(() => {
          this.$postJSON(`${apis.locationDelete}/${data.locationId}`).then(() => {
            this.$message({
              type: 'success',
              message: this.$t('Common.com_delete_success'),
            });
            this.getTableList();
          });
        })
        .catch(() => {});
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 确认保存
    confirm: function () {
      this.visible = false;
      this.$emit('success', this.selectedRow);
    }
  }
};
</script>

<style lang="scss"></style>
